import React from "react"
import { Button } from "@cirrus/ui-kit-ts"
import { useTranslations } from "@cirrus/core/i18n/provider"
import { useNavigationService } from "../providers/NavigationService"

export const ButtonLoginWithSaml = () => {
	const { i18n } = useTranslations()
	const { navigate } = useNavigationService()

	return <Button
		type="button"
		label={`${i18n("Account.Login:LoginWith")} SAML 2.0`}
		variant="outlined"
		onClick={() => navigate("/saml")}
	/>
}
